import React from "react";
import { Button, Stack, Tooltip } from "@mui/material";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import MergeTypeOutlinedIcon from "@mui/icons-material/MergeTypeOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import { useTranslation } from "react-i18next";

const actionBtnSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: 1.5,
  whiteSpace: "nowrap",
};

function ActionButton({ tooltip, disabled, onClick, startIcon, children, color = "primary" }) {
  const btn = (
    <Button
      size="small"
      variant="outlined"
      color={color}
      disabled={disabled}
      onClick={onClick}
      startIcon={startIcon}
      sx={actionBtnSx}
    >
      {children}
    </Button>
  );

  if (tooltip && disabled) {
    return (
      <Tooltip title={tooltip}>
        <span>{btn}</span>
      </Tooltip>
    );
  }

  return btn;
}

export default function ClientBulkActions({
  selectedRows,
  selectedIds,
  selectedCount,
  hasActiveFilters,
  onReviewSelected,
  onReviewFilter,
  onMergeSelected,
  onPortalInviteSelected,
  portalInviteDisabled = false,
  portalInviteDisabledReason = "",
  onCreateCampaignSelected,
  campaignCreateEnabled = false,
}) {
  const { t } = useTranslation("settings");
  const count = Number(selectedCount) || 0;

  const mergeDisabled = count < 2 || count > 5;
  const mergeReason =
    count < 2
      ? t("clientTable.bulkMergeMin")
      : count > 5
        ? t("clientTable.bulkMergeMax")
        : "";

  const reviewDisabled = count < 1 && !hasActiveFilters;
  const reviewLabel =
    count > 0 ? t("clientTable.bulkReview") : t("clientHygiene.reviewFilterButton");

  const portalInviteDisabledState = count < 1 || portalInviteDisabled;
  const portalInviteReason =
    count < 1
      ? t("clientTable.portalInviteNeedSelection")
      : portalInviteDisabledReason || t("clientTable.portalInviteChannelRequired");

  return (
    <Stack direction="row" flexWrap="wrap" gap={0.75} alignItems="center" useFlexGap>
      <ActionButton
        disabled={reviewDisabled}
        onClick={() => {
          if (count > 0) onReviewSelected?.(selectedRows);
          else onReviewFilter?.();
        }}
        startIcon={<FactCheckOutlinedIcon fontSize="small" />}
      >
        {reviewLabel}
      </ActionButton>

      <ActionButton
        disabled={mergeDisabled}
        tooltip={mergeReason}
        onClick={() => {
          if (mergeDisabled) return;
          onMergeSelected?.(selectedRows);
        }}
        startIcon={<MergeTypeOutlinedIcon fontSize="small" />}
      >
        {t("clientTable.bulkMerge")}
      </ActionButton>

      <ActionButton
        disabled={portalInviteDisabledState}
        tooltip={portalInviteReason}
        onClick={() => {
          if (portalInviteDisabledState) return;
          onPortalInviteSelected?.(selectedRows, selectedIds);
        }}
        startIcon={<SupportAgentOutlinedIcon fontSize="small" />}
      >
        {t("clientTable.bulkPortalInvite")}
      </ActionButton>

      {campaignCreateEnabled ? (
        <ActionButton
          disabled={count < 1}
          tooltip="Selecione ao menos um cliente"
          onClick={() => {
            if (count < 1) return;
            onCreateCampaignSelected?.(selectedRows, selectedIds);
          }}
          startIcon={<CampaignOutlinedIcon fontSize="small" />}
        >
          Criar disparo
        </ActionButton>
      ) : null}
    </Stack>
  );
}
